import React from "react";
import "./details.css";

const DetailsTable = ({ companyData }) => {
  console.log("companyData in details table:", companyData);

  return (
    <div className="details-page mt-3">
      <h2>Company Details</h2>
      {/* 
      <div className="row d-flex justify-content-between align-items-center mt-3">
        <div className="col-md-3 details-page-content">
          <h3>Company Name:</h3>
          <p>{companyData?.companyName}</p>

          <h3>Registration Date</h3>
          <p>
            {companyData?.createdAt
              ? new Date(companyData.createdAt).toLocaleDateString()
              : "-"}
          </p>
        </div>

        <div className="col-md-3 details-page-content">
          <h3>Email Address</h3>
          <p>{companyData?.companyEmail}</p>

          <h3>Status</h3>
          <button className="details-active-btn">{companyData?.status}</button>
        </div>

        <div className="col-md-3 details-page-content">
          <h3>Mobile Number</h3>
          <p>
            {companyData?.companyPhoneCode} {companyData?.companyPhoneNumber}
          </p>
        </div>

        <div className="col-md-3 details-page-content">
          <h3>Client Name</h3>
          <p>{companyData?.clientName}</p>
        </div>
      </div> */}

      {/* ✅ Certification Details */}
      <div className="certification-details mt-4 row">
        {/* <h2>Certifications</h2> */}
        {companyData?.certificationIds?.length > 0 ? (
          companyData.certificationIds.map((cert, index) => {
            // Filter alternate emails — exclude if same as main company email
            const filteredAltEmails = cert.alternateEmails?.filter(
              (email) => email !== companyData?.companyEmail
            );

            return (
              <div
                key={cert._id || index}
                className="details-page-content mt-3 row"
              >
                <h3
                  style={{
                    color: "#127285",
                    fontSize: "20px",
                    fontWeight: 700,
                  }}
                >
                  {cert.certificationNumber}
                </h3>
                <div className="col-md-3">
                  <p>
                    <strong>Company Name:</strong> {cert.companyName}
                  </p>
                  <p>
                    <strong>City:</strong> {cert.city}
                  </p>
                  <p>
                    <strong>Email:</strong> {cert.email}
                  </p>
                </div>
                <div className="col-md-3">
                  <p>
                    <strong>Standard:</strong> {cert.standard}
                  </p>
                   <p>
                  <strong>Mobile Number:</strong> {cert.companyPhoneNumber}
                </p>
                <strong>Status</strong>{" "}
                <button className="details-active-btn">{cert.status}</button>
                </div>
               
                  <div className="col-md-3">
                       <p>
                  <strong>Registration Date:</strong>{" "}
                  {new Date(cert.dateOfRegistration).toLocaleDateString()}
                </p>
                <p>
                  <strong>Certification Expiry:</strong>{" "}
                  {new Date(cert.certificationExpiryDate).toLocaleDateString()}
                </p>
               
                  </div>
                  <div className="col-md-3">
                      {/* Show Alternate Emails only if unique */}
                {filteredAltEmails?.length > 0 ? (
                  <div>
                    <strong>Alternate Emails:</strong>
                    <ul>
                      {filteredAltEmails.map((email, i) => (
                        <li key={i}>{email}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <p>No alternate emails available</p>
                )}
                
                  </div>
              </div>
            );
          })
        ) : (
          <p>No certifications found</p>
        )}
      </div>
    </div>
  );
};

export default DetailsTable;
